import { render, staticRenderFns } from "./ResultPredictionComponent.vue?vue&type=template&id=7ce0a369&"
import script from "./ResultPredictionComponent.vue?vue&type=script&lang=js&"
export * from "./ResultPredictionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports